import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider } from './contexts/AuthContext';
import { VehicleProvider } from './contexts/VehicleContext';
import ProtectedRoute from './components/protected-route';
import ChatPage from "./pages/ChatPage";
import PreviewChatPage from "./pages/PreviewChatPage";
import SignInPage from "./pages/SignInPage";
import ViewChatPage from "./pages/ViewChatPage";
import RegistrationPage from "./pages/RegistrationPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import "./App.css"

function App() {
  return (
    <Router>
      <AuthProvider>
        <VehicleProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<SignInPage />} />
            <Route path="/register" element={<RegistrationPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/preview" element={<PreviewChatPage />} />
            <Route path="/view/:chatId" element={<ViewChatPage />} />
            
            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<ChatPage />} />
              <Route path="/chat/:chatId" element={<ChatPage />} />
            </Route>
            
            {/* Redirect to home for unknown routes */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </VehicleProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
